import reference from './reference.json';
export const isSponsorshipPath = (path) =>
  /^\/sponsorship(?:\/(?:benefits|vision|roster))?\/?$/.test(path);
export function publicPolicy(catalog, locale) {
  const local = reference.policy[locale === 'en' ? 'en' : 'ko'];
  const base = locale === 'en' ? local : { ...local, ...catalog?.policy };
  return {
    ...base,
    tiers: (Array.isArray(base.tiers) && base.tiers.length ? base.tiers : local.tiers).map(
      (tier) => ({ ...tier, ...(local.tiers.find((t) => t.key === tier.key) || {}) }),
    ),
    milestones: local.milestones,
    cancellationRules: local.cancellationRules,
    nicknameColors: (Array.isArray(base.nicknameColors) && base.nicknameColors.length
      ? base.nicknameColors
      : local.nicknameColors
    ).map((color) => local.nicknameColors.find((x) => x.key === color.key) || color),
  };
}
export function publicProducts(catalog) {
  const valid = catalog?.products?.filter?.(
    (p) =>
      p &&
      ['MONTHLY', 'ONE_TIME'].includes(p.kind) &&
      typeof p.productId === 'string' &&
      p.productId &&
      Number.isFinite(p.amount) &&
      p.amount > 0 &&
      /^[A-Z]{3}$/.test(p.currency),
  );
  return valid?.length ? valid : reference.products;
}
export function rosterColor(color, dark, fallback) {
  const value =
    color?.key === 'VINYL' ? (dark ? '#FF79AD' : '#B8326A') : color?.[dark ? 'dark' : 'light'];
  return /^#[0-9a-f]{6}$/i.test(value || '') ? value : fallback;
}
